<nb-card>
  <nb-card-header>
    <h6>{{ title ? title : "Share link" }}</h6>

    <button nbButton ghost size="small" (click)="close()" status="primary">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <ngx-view-qrcode [qrdata]="link"> </ngx-view-qrcode>

    <div class="form-inline">
      <nb-form-field fullWidth>
        <input
          type="text"
          nbInput
          fullWidth
          disabled
          shape="semi-round"
          class="form-control"
          [(ngModel)]="link"
        />
        <button
          nbSuffix
          nbButton
          ghost
          shape="semi-round"
          nbTooltip="Copy link"
          (click)="copyLink()"
        >
          <nb-icon icon="copy-outline"> </nb-icon>
        </button>
      </nb-form-field>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <nb-actions size="none">
      <nb-action (click)="openLink()">
        <nb-icon
          [status]="'info'"
          class="action-icon"
          icon="external-link-outline"
        ></nb-icon>
        Mở liên kết link
      </nb-action>

      <nb-action (click)="copyLink()">
        <nb-icon
          [status]="'info'"
          class="action-icon"
          icon="copy-outline"
        ></nb-icon>
        Sao chép link
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
